import Button from "@material-ui/core/Button";
import { httpClient } from "api/httpClient";
import { useSimpleModalToggle } from "components/dialogs/useSimpleModal";
import React, { useMemo, useState } from "react";
import { Confirm, useNotify, useRefresh, useTranslate } from "react-admin";
import { useNotifyError } from "utils/notifiers/useNotifyError";

export const GenerateAllPalletsButton = ({
	orderId,
	disabledGenerateAllPallets,
	orderProductArticles,
	...props
}) => {
	const { open, handleOpen, handleClose } = useSimpleModalToggle();
	const notify = useNotify();
	const notifyError = useNotifyError();
	const translate = useTranslate();
	const refresh = useRefresh();

	const initialIsRegeneration = useMemo(() => {
		return Object.values(orderProductArticles || {}).some(
			(article) => article.is_pallets_generated === true
		);
	}, [orderProductArticles]);

	const [isRegeneration, setIsRegeneration] = useState(initialIsRegeneration);
	const [loading, setLoading] = useState(false);

	const handleGenerateAll = async () => {
		setLoading(true);
		try {
			const orderProductArticleIds = Object.values(orderProductArticles).map((item) => item.id);

			const { json } = await httpClient(`/orders/${orderId}/generate-pallets`, {
				method: "POST",
				body: JSON.stringify({ order_product_article_ids: orderProductArticleIds }),
			});

			handleClose();
			notify(
				translate(
					isRegeneration
						? "osfc.dialogs.regenerate-pallets.success"
						: "osfc.dialogs.generate-pallets.success"
				),
				"success"
			);
			setIsRegeneration(json.is_pallets_generated);
			refresh();
		} catch (error) {
			notifyError(error);
		} finally {
			setLoading(false);
		}
	};

	return (
		<>
			<Button
				size="small"
				variant="outlined"
				color="primary"
				disabled={disabledGenerateAllPallets}
				onClick={handleOpen}
			>
				{translate(
					isRegeneration
						? "osfc.buttons.regenerate-all-pallets"
						: "osfc.buttons.generate-all-pallets"
				)}
			</Button>
			<Confirm
				isOpen={open}
				loading={loading}
				title={translate(
					isRegeneration
						? "osfc.dialogs.regenerate-pallets.title"
						: "osfc.dialogs.generate-all-pallets.title"
				)}
				content={translate(
					isRegeneration
						? "osfc.dialogs.regenerate-pallets.content"
						: "osfc.dialogs.generate-pallets.content"
				)}
				onConfirm={handleGenerateAll}
				onClose={handleClose}
				confirm="osfc.buttons.confirm"
			/>
		</>
	);
};
